import React from 'react';
import SectionHeading from '../Typography/SectionHeading/SectionHeading';
import EditButton from '../Typography/EditButton/EditButton';
import { beneficiaryLine1, beneficiaryLine2, beneficiaryLine3 } from './util';
import styles from '../ReviewCombinedPersonalInformation/style.css';
import { formatBeneficiariesForList } from '../../screens/BeneficiariesScreen/util';
import { generateGeneralTestID } from '../../generateAutomationTestIDs';

const beneficiariesList = benes => {
  return (
    <>
      {benes.map((bene, idx) => {
        return (
          /* eslint-disable react/jsx-key */
          <div className="customer-information-lines">
            <div
              data-name={generateGeneralTestID(
                'Review',
                'BeneficiarySummaryLine1'
              )}>
              {beneficiaryLine1(bene)} %
            </div>
            <div
              data-name={generateGeneralTestID(
                'Review',
                'BeneficiarySummaryLine2'
              )}>
              {beneficiaryLine2(bene)}
            </div>
            <div
              data-name={generateGeneralTestID(
                'Review',
                'BeneficiarySummaryLine3'
              )}
              className="nasu_masking_class">
              {beneficiaryLine3(bene)}
            </div>{' '}
            {idx !== benes.length - 1 && <br />}
          </div>
        );
      })}
      <style jsx>{styles}</style>
    </>
  );
};

const beneficiariesSection = (benes, benesType, handleClick) => {
  return (
    <div className="bene-info review-customer-information">
      <div className="section-header">
        <SectionHeading text={`My ${benesType} Beneficiaries`}>
          <EditButton
            onClick={handleClick('beneficiaries')}
            currentlyEditing={false}
          />
        </SectionHeading>
      </div>

      {beneficiariesList(benes)}

      <style jsx>{styles}</style>
    </div>
  );
};

const ReviewBeneficiaries = ({ beneficiaries, handleClick }) => {
  const { primary, secondary } = formatBeneficiariesForList(beneficiaries);
  return (
    <>
      {primary.length > 0 &&
        beneficiariesSection(primary, 'Primary', handleClick)}
      {secondary.length > 0 &&
        beneficiariesSection(secondary, 'Secondary', handleClick)}
    </>
  );
};

export default ReviewBeneficiaries;
